<template>
    <div class="bookingsearch col-lg-8 col-md-8 col-xs-12">
        <h2 v-show="isReducedView == false" v-html="addressSearchHeader || TEXTS.render(`ADDRESS_SEARCH_HEADER`)"></h2> 
        <booking-search :isReducedView="isReducedView"/>
    </div>
</template>

<script>
    import BookingSearch from './BookingSearch';
    import Texts from '../utils/Texts'
    export default {
        components: {
            BookingSearch
        },
        props: {
            isReducedView: {
                type: Boolean,
                default: false
            },
        },
        mounted() {
            // this.$store.dispatch('getSiteWordingsSettings');
        },
        computed : {
            TEXTS(){
                return Texts
            },
            siteWordings() {
                return this.$store.getters['GET_SITE_WORDINGS']; 
            },
            addressSearchHeader(){
                const addressSearchHeader = this.siteWordings ? this.siteWordings.search_title : null
                return addressSearchHeader || Texts.render(`ADDRESS_SEARCH_HEADER`)
            }
        }
    }
</script>